import { Redirect, useLocation } from 'react-router-dom';

import { getCurrentPath, getSafeNextQueryParam, toQueryString } from '../../UrlQueryParam';

interface Props {
  redirectPath: string;
}

/**
 * Redirects a user while preserving the `next` param (or placing the current path in the `next` param)
 *
 * Most commonly used with authentication (ie: if a user isn't signed in and attempts to navigate to a
 * path that requires authentication, we'll redirect them to a sign in page and place the path they originally
 * navigated to in the `next` param).
 */
export const RedirectWithNextParam: React.FC<Props> = (props) => {
  const { redirectPath } = props;
  const { search } = useLocation();
  const newSearchQuery = toQueryString({
    next: getSafeNextQueryParam(search) ?? getCurrentPath(),
  });

  return (
    <Redirect
      to={{
        pathname: redirectPath,
        search: newSearchQuery,
      }}
    />
  );
};
